import { render, staticRenderFns } from "./TaskTimeline.vue?vue&type=template&id=3224e866"
import script from "./TaskTimeline.vue?vue&type=script&lang=ts"
export * from "./TaskTimeline.vue?vue&type=script&lang=ts"
import style0 from "./TaskTimeline.vue?vue&type=style&index=0&id=3224e866&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports